import {i18n} from "@/plugins/i18n";

export default [
    {
        field: 'id',
        title: i18n.t('online-factor.hash_id'),
        sortable: true,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'name',
        title: i18n.t('online-factor.name'),
        sortable: false,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'creator',
        title: i18n.t('online-factor.creator'),
        sortable: false,
        template: (row) => {
            return '<a href="/customers/' + row.user.id + '/details"><span dir="ltr">' + row.user.full_name + '</span></a>'
        },
        width: 120,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('online-factor.created_at'),
        sortable: true,
        width: 80,
        textAlign: 'center',
    },
]